import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/googleAds';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track page view for Google Ads
    trackPageView(pathname, document.title);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
